<template>
    <div :class="['alert-msg', type]" v-if="show" v-html="message"></div>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
    data: function() {
        return {
            message: null,
            type: 'error',
            show: false,

            timeOut: null,
        };
    },

    mounted() {
        EventBus.$on('show-alert', (message, type = 'error', time = 7000) => {
            this.message = message;
            this.type = type;

            if(this.timeOut !== null) {
                clearTimeout(this.timeOut);
            }

            this.show = true;

            this.timeOut = setTimeout(() => {
                this.show = false;
            }, time);
        });
    },
}
</script>

<style lang="scss">
    .alert-msg {
        position: absolute!important;
        top: 0;
        left: 0;
        text-align: center;
        width: 100%;
        z-index: 100;
        height: auto;
        padding: 3px;
        margin: 0;
        font-size: 14px;
        font-weight: 300;
        border-radius: 0;

        background: rgba(#4fbb8a, .98);
        color: #fff;

        &.error {
            background: rgba(#e13430, .98);
        }

        &.warning {
            background: rgba(#f59c25, .98);
        }
    }
</style>